import React, { memo } from 'react';
import { format } from 'date-fns';
import * as GStyled from '../../../styles/components';
import * as Styled from './styled';
import { ReportSnapshot } from '../../../models';
import { REPORT_CURRENCIES, DATE_TIME_FORMAT } from '../../../constants';
import ReportSettingPIT from './ReportSettingPIT';
import { Icon } from '../../../components';

interface ReportSettingProps {
  reportSnapshot: ReportSnapshot;
}

function ReportSettingAssetAmort({
  reportSnapshot,
}: ReportSettingProps): JSX.Element {
  const { currency, asOfDate1 } = reportSnapshot;

  return (
    <>
      <Styled.ReportSettingItem>
        <Icon name="calendar" />
        <GStyled.Text>Report End Date</GStyled.Text>
        <GStyled.Text fontWeight="medium">
          {format(asOfDate1, DATE_TIME_FORMAT.MONTH_YEAR)}
        </GStyled.Text>
      </Styled.ReportSettingItem>
      <ReportSettingPIT reportSnapshot={reportSnapshot} />
      <Styled.ReportSettingItem>
        <Icon name="currency" />
        <GStyled.Text>Currency</GStyled.Text>
        <GStyled.Text fontWeight="medium">
          {REPORT_CURRENCIES[currency].label}
        </GStyled.Text>
      </Styled.ReportSettingItem>
    </>
  );
}

export default memo(ReportSettingAssetAmort);
